import {Navigate, Route, Routes as RoutesDOM} from "react-router-dom";
import {PrivateRoute} from "components/PrivateRoute";
import {NotAuthOnlyRoute} from "components/NotAuthRoute";
import {CheckTerms} from "components/CheckTerms";
import React, {lazy, Fragment, Suspense} from "react";
import {useIsMobile} from "modules/utils";
import UserProfile from "pages/UserProfile";
import GroupPage from "pages/group/Group";
import GroupTable from "pages/group/GroupTable";
import GroupInvites from "pages/group/GroupInvites";
import GroupSettings from "pages/group/GroupSettings";
import JoinGroupByCode from "pages/groups/JoinGroupByCode";
import {PagePreloader} from "components";

const Groups = lazy(() => import("pages/Groups"));
const MyGroups = lazy(() => import("pages/groups/MyGroups"));
const CreateGroup = lazy(() => import("pages/groups/CreateGroup"));
const JoinGroups = lazy(() => import("pages/groups/JoinGroups"));
const PlayerPool = lazy(() => import("pages/PlayerPool"));
const HistoryPage = lazy(() => import("pages/HistoryPage"));
const BatterPage = lazy(() => import("pages/BatterPage"));
const FriendsPicksPage = lazy(() => import("pages/FriendsPicksPage"));
const LeadersPage = lazy(() => import("pages/LeadersPage"));
const Leaderboards = lazy(() => import("pages/Leaderboards"));
const FuturePicksPage = lazy(() => import("pages/FuturePicksPage"));
const NotFound = lazy(() => import("pages/NotFound"));
const BackDoorPage = lazy(() => import("pages/BackDoorPage"));
const HomePage = lazy(() => import("pages/HomePage"));
const Logout = lazy(() => import("pages/Logout"));
// const Terms = lazy(() => import("./pages/HowToPlay"));
const HowToPlay = lazy(() => import("./pages/HowToPlay"));
const Rewards = lazy(() => import("./pages/Rewards"));
const CurrentBadge = lazy(() => import("./pages/CurrentBadge"));

const batterPageRoute = <Route path={":playerId/:matchID"} element={<BatterPage />} />;

const playerPoolRoutes = (
	<Route path={"players/:gameRoundId"} element={<PlayerPool />}>
		{batterPageRoute}
	</Route>
);

const viewportRoutes = (
	<Fragment>
		<Route path={"/leaderboard"} element={<Leaderboards />}>
			<Route path={":userId"} element={<UserProfile />} />
		</Route>
		<Route path={"groups"} element={<Groups />}>
			<Route index={true} element={<MyGroups />} />
			<Route path={"create"} element={<CreateGroup />} />
			<Route path={"join"} element={<JoinGroups />}>
				<Route path={":code"} element={<JoinGroupByCode />} />
			</Route>
			<Route path=":id" element={<GroupPage />}>
				<Route index element={<Navigate to="about" replace />} />
				<Route path="table" element={<GroupTable />}>
					<Route path={":userId"} element={<UserProfile />} />
				</Route>
				<Route path="invites" element={<GroupInvites />} />
				<Route path="about" element={<GroupSettings />} />
				<Route path="*" element={<Navigate to="about" replace />} />
			</Route>
		</Route>
	</Fragment>
);

const Routes: React.FC = () => {
	const isMobile = useIsMobile();
	return (
		<Suspense fallback={<PagePreloader />}>
			<RoutesDOM>
				<Route path={`/`} element={<HomePage />}>
					<Route index={true} element={<PlayerPool />} />

					<Route path={"/history"} element={<HistoryPage />}>
						<Route path={"/history/:playerId/:matchID"} element={<BatterPage />} />
					</Route>
					<Route path={"/friends"} element={<FriendsPicksPage />} />
					<Route path={"/leaders"} element={<LeadersPage />} />

					{!isMobile && viewportRoutes}

					<Route path={"/future-picks"} element={<FuturePicksPage />}>
						{playerPoolRoutes}
						{batterPageRoute}
					</Route>

					{playerPoolRoutes}
					{batterPageRoute}
				</Route>
				{isMobile && viewportRoutes}
				<Route element={<PrivateRoute />}>
					<Route path={`/logout`} element={<Logout />} />
				</Route>
				<Route element={<NotAuthOnlyRoute />}>
					<Route path={`/backdoor`} element={<BackDoorPage />} />
				</Route>
				<Route path="/rewards" element={<Rewards />} />
				<Route path="/rewards/:reward" element={<CurrentBadge />} />
				<Route path="/how-to-play" element={<HowToPlay />} />
				<Route path="/terms" element={<CheckTerms />} />
				<Route path="*" element={<NotFound />} />
			</RoutesDOM>
		</Suspense>
	);
};

export default Routes;
